export const RESPONSE_COLUMN_LABEL_KEYS = {
  serialNumber: "campaigns.columns.serialNumber",
  model: "campaigns.columns.model",
  deviceStatus: "campaigns.columns.deviceStatus",
  remarks: "campaigns.columns.remarksComments",
} as const;

export const CAMPAIGN_TABS = {
  myBaselining: "my-baselining",
  myTeamBaselining: "my-team-baselining",
} as const;

export const LINKED_REPORT_QUERY_PARAM = "report";

export const ALIAS_PATTERN = /^[a-z0-9._-]{1,64}$/;

export const DIGITS_ONLY = /^\d+$/;
